export const scrollToTop = () => {
  document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
};
